import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./home/home.component')
            .then(c => c.HomeComponent)
    },
    {
        path: 'create',
        loadComponent: () => import('./create-page/create-page.component')
            .then(c => c.CreatePageComponent)
    },
    {
        path: 'shop',
        loadComponent: () => import('./common-shop/common-shop.component')
            .then(c => c.CommonShopComponent)
    },
    {
        path: 'tees',
        loadComponent: () => import('./your-tees/your-tees.component')
            .then(c => c.YourTeesComponent)
    },
    {
        path: 'account',
        loadComponent: () => import('./setting-page/setting-page.component')
            .then(c => c.SettingPageComponent)
    },
    {
        path: 'buy/:userId',
        loadComponent: () => import('./buy-page/buy-page.component')
            .then(c => c.BuyPageComponent)
    },
    {
        path: ':userName/merch/:userId',
        loadComponent: () => import('./merch-home-page/merch-home-page.component')
            .then(c => c.MerchHomePageComponent)
    },
    {
        path: 'refferedBy/:userName',
        loadComponent: () => import('./home/home.component')
            .then(c => c.HomeComponent)
    },
    {
        path: 'admin',
        loadComponent: () => import('./tshirt-preview/tshirt-preview.component')
            .then(c => c.TshirtPreviewComponent)
    },
    {
        path: 'order/:id',
        loadComponent: () => import('./vendor-dashboard/vendor-dashboard.component')
            .then(c => c.VendorDashboardComponent)
    },
    {
        path: '**',
        loadComponent: () => import('./not-found/not-found.component')
            .then(c => c.NotFoundComponent)
    }
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
